module.exports = __webpack_public_path__ + "img/home_background.f9517bab.jpg";